document.addEventListener("DOMContentLoaded", () => {
  const needle = "Bestellen verloopt via onze webshop: www.slaatsbikeparts.nl";

  document
    .querySelectorAll(".product__description, .rte")
    .forEach((root) => {
      root.querySelectorAll("p, li").forEach((el) => {
        const text = el.textContent.replace(/\s+/g, " ").trim();
        if (text === needle || text.includes(needle)) {
          el.style.display = "none";
        }
      });
    });
});
